import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * False on the server and during hydration, true on every client render after that.
 * Use it to keep browser-only state (e.g. localStorage) out of the hydration render, so it matches the server HTML.
 */
const useIsHydrated = () =>
  useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );

export default useIsHydrated;
